// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2FAInfo_newTabIcon__nJ4J0{fill:currentColor;text-align:center}", ""]);
// Exports
exports.locals = {
	"newTabIcon": "_2FAInfo_newTabIcon__nJ4J0"
};
module.exports = exports;
